// # Friends section component for profile
import React from 'react';
import './prfl_friends.css';

const ProfileFriends = ({ isDarkMode }) => {
  return (
    <div className={`prfl_friends_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_friends_coming-soon">
        <h3>Friends Feature Coming Soon</h3>
        <p>Connect with fellow medical students and professionals.</p>
      </div>
    </div>
  );
};

export default ProfileFriends;
